<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>保证金管理</h1>
        <p>应缴金额由平台填写。渠道没单独设置时，用该级别政策里的应缴保证金。已确认余额不够的部分就是还需补缴。超期只作提醒，不会自动取消资格。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">已确认余额合计</div><div class="v">¥ {{ yuan(balance) }}</div></div>
      <div class="ch-metric"><div class="k">流水笔数</div><div class="v">{{ rows.length }}</div></div>
      <div class="ch-metric"><div class="k">待确认</div><div class="v">{{ pending }}</div></div>
    </div>
    <div class="ch-panel">
      <h2>按渠道</h2>
      <table class="ch-table">
        <thead><tr><th>渠道</th><th>应缴金额</th><th>已确认余额</th><th>还需补缴</th><th>待确认笔数</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in grouped" :key="row.id">
            <td>{{ row.name }}</td>
            <td>¥ {{ yuan(row.required) }}</td>
            <td>¥ {{ yuan(row.balance) }}</td>
            <td>¥ {{ yuan(gap(row)) }}</td>
            <td>{{ row.pending }}</td>
            <td><button class="ch-link" type="button" @click="setRequired(row)">设置应缴</button></td>
          </tr>
          <tr v-if="!grouped.length"><td colspan="6" class="ch-empty">还没有渠道</td></tr>
        </tbody>
      </table>
    </div>
    <div class="ch-panel">
      <h2>流水</h2>
      <table class="ch-table">
        <thead><tr><th>时间</th><th>渠道</th><th>方向</th><th>金额</th><th>状态</th><th>备注</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in rows" :key="row.id">
            <td>{{ row.createdAt }}</td>
            <td>{{ nameOf(row.partnerId) }}</td>
            <td>{{ row.direction === 'OUT' ? '退还' : '缴纳' }}</td>
            <td>{{ row.direction === 'OUT' ? '-' : '+' }}{{ yuan(row.amount) }}</td>
            <td><span class="ch-tag" :class="row.status === 'CONFIRMED' ? 'ok' : (row.status === 'REJECTED' ? 'bad' : 'warn')">{{ depositStatus(row.status) }}</span></td>
            <td>{{ row.remark || '—' }}</td>
            <td>
              <button v-if="row.status === 'PENDING'" class="ch-link" type="button" @click="review(row, 'confirm')">确认到账</button>
              <button v-if="row.status === 'PENDING'" class="ch-link" type="button" @click="review(row, 'reject')">驳回</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelPartners, getChannelDeposits, getChannelPolicies, reviewChannelDeposit, saveChannelDeposit } from '@/api/admin'
import { yuan } from '../partner/labels'
import { partnerName } from './lookup'

export default {
  name: 'HqDeposits',
  data() {
    return { partners: [], rows: [], policies: [], balance: 0 }
  },
  computed: {
    pending() { return this.rows.filter(item => item.status !== 'CONFIRMED').length },
    grouped() {
      const map = {}
      this.partners.forEach(partner => {
        map[partner.id] = { id: partner.id, name: partner.name || this.nameOf(partner.id), required: this.requiredOf(partner), balance: 0, pending: 0 }
      })
      this.rows.forEach(row => {
        const id = row.partnerId
        if (!map[id]) map[id] = { id, name: this.nameOf(id), required: 0, balance: 0, pending: 0 }
        if (row.status === 'CONFIRMED') {
          const amount = Number(row.amount || 0)
          map[id].balance += row.direction === 'OUT' ? -amount : amount
        } else if (row.status !== 'REJECTED') {
          map[id].pending += 1
        }
      })
      return Object.keys(map).map(key => map[key])
    }
  },
  created() { this.load() },
  methods: {
    yuan,
    nameOf(id) { return partnerName(this.partners, id) },
    requiredOf(partner) {
      if (partner.depositRequired != null && partner.depositRequired !== '') return Number(partner.depositRequired)
      const policy = this.policies.find(item => item.levelCode === partner.levelCode)
      return policy && policy.depositAmount != null ? Number(policy.depositAmount) : 0
    },
    gap(row) { return Math.max(0, Number(row.required || 0) - Number(row.balance || 0)) },
    async setRequired(row) {
      try {
        const result = await this.$prompt('填写「' + row.name + '」需要缴纳的保证金，单位元', '设置应缴金额', {
          inputValue: String(row.required || 0),
          inputPattern: /^\d+(\.\d{1,2})?$/,
          inputErrorMessage: '请填写金额'
        })
        await saveChannelDeposit({ action: 'setRequired', partnerId: row.id, amount: result.value })
        this.$message.success('已保存应缴金额')
        this.load()
      } catch (e) {
        if (e === 'cancel') return
      }
    },
    depositStatus(status) {
      if (status === 'CONFIRMED') return '已确认'
      if (status === 'REJECTED') return '已驳回'
      return '待确认'
    },
    async review(row, action) {
      await reviewChannelDeposit(row.id, { action })
      this.load()
    },
    async load() {
      const partners = await getChannelPartners()
      const deposits = await getChannelDeposits()
      const policies = await getChannelPolicies()
      this.partners = partners.list || []
      this.rows = deposits.list || []
      this.policies = policies.list || []
      this.balance = deposits.balance || 0
    }
  }
}
</script>
